import { makeAutoObservable } from "mobx";
import { FetchStatusEnum, FetchStatusStrings } from "../../enums/fetchStatusEnum";

import authUserStore from "../auth/store";
import { IncomeInviteSchema } from "./schemas";
import InvitesApi from "./api";


class Store {
    private invites: IncomeInviteSchema[] = [];
    private fetching: FetchStatusStrings = FetchStatusEnum.IDLE;

    constructor() {
        makeAutoObservable(this);
        this.prefetchData();
    }

    get getInvites(): IncomeInviteSchema[] {
        return this.invites;
    }
    setInvites(invites: IncomeInviteSchema[]): void  {
        this.invites = invites;
    }
    removeInviteById(inviteId: number): void  {
        this.invites = this.invites.filter(invite => invite.id !== inviteId);
    }

    setFetchStatus(newStatus: FetchStatusStrings): void {
        this.fetching = newStatus;
    }
    get getFetchStatus(): FetchStatusStrings {
        return this.fetching;
    }

    prefetchData = () => {
        if (!authUserStore.isLogin) return;

        InvitesApi.get_income().then((invites: IncomeInviteSchema[]) => {
            this.setInvites(invites);
            this.setFetchStatus(FetchStatusEnum.SUCCESS);
        }).catch(() => {
            this.setFetchStatus(FetchStatusEnum.ERROR);
        });
    };
}


const invitesStore = new Store();
export default invitesStore;
